import React from "react";
import { Card } from "react-bootstrap";

import TablaSindromes from "./TablaSindromes";

const Sindromes = () => {
  return (
    <Card>
      <Card.Header
        style={{
          backgroundColor: "#F5E6D3",
          color: "#5E8C5A",
          fontWeight: "bold",
        }}
        as="h3"
      >
        Síndromes/Enfermedades
      </Card.Header>
      <Card.Body>
        <TablaSindromes />
      </Card.Body>
    </Card>
  );
};

export default Sindromes;
